module.exports = __webpack_public_path__ + "img/vennhorizontal.07053f6a.png";